import { Fragment } from 'react/jsx-runtime';

interface ChartBenchmarkGridProps {
  benchmarkDetails: any;
  bottomOffset: string;
}

function ChartBenchmarkGrid({
  benchmarkDetails,
  bottomOffset,
}: ChartBenchmarkGridProps) {
  return (
    <div>
      {[
        benchmarkDetails.thriving,
        benchmarkDetails.attention,
        benchmarkDetails.global,
      ].map(({ value, color }) => (
        <Fragment key={value}>
          {/* Label */}
          <div
            className="absolute top-0.5 z-[2] inline-block -translate-x-1/2"
            style={{ left: `${value}%` }}
          >
            <span
              className="rounded-lg px-2 py-1 text-[10px] font-semibold text-white"
              style={{ backgroundColor: color }}
            >
              {Math.round(value)}
            </span>
            <div
              className="clip-top absolute -bottom-1 left-1/2 h-2 w-4 -translate-x-1/2"
              style={{ backgroundColor: color }}
            />
          </div>

          {/* Dashed Line */}
          <div
            className={`absolute top-8 z-[2] w-px -translate-x-1/2 ${bottomOffset}`}
            style={{
              left: `${value}%`,
              backgroundImage: `repeating-linear-gradient(to bottom, ${color} 0, ${color} 6px, transparent 6px, transparent 10px)`,
            }}
          />
        </Fragment>
      ))}
    </div>
  );
}

export default ChartBenchmarkGrid;
